import index from './index.vue';
import { FirmwareForm } from './all.type';

export default index;
export {
    FirmwareForm
};